export default function RenderAnchorHtmlOrStr(props: any) {
    const { content } = props
    const hasAnchorTag = /<a\s+[^>]*href=/.test(content);

    return hasAnchorTag ? (
        <div
            dangerouslySetInnerHTML={{ __html: content }}
        />
    ) : (
        <div >{content}</div>
    );
}
